import $ from 'jquery'; 
window.jQuery = $; 
window.$ = $;
import * as bootstrap from './bootstrap';

window.bootstrap = bootstrap;